import { useState, useEffect } from "react";

const useMobileCheck = (breakpoint = 1000) => {
  const [mobile, setMobile] = useState(window.innerWidth <= breakpoint);
  const [hamburger, setHamburger] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth <= breakpoint);
      setHamburger(window.innerWidth <= breakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return { mobile, hamburger, setHamburger };
};

export default useMobileCheck;
